import tracr from 'tracr-sdk'

import isClient from '@equifax-ui/utils/browser/isClient'

import {
  TRACR_ANONYMOUS_ID_LABEL,
  TRACR_SESSION_ID_LABEL
} from '@/constants/api'

import { newRelicNotifyError } from './trackingNewRelic'

const { sendEvent } = tracr.Events

export const getTracrAnonymousId = async () => {
  if (!isClient()) return

  try {
    const valueFromStorage = localStorage.getItem(TRACR_ANONYMOUS_ID_LABEL)

    if (!valueFromStorage) return undefined

    return valueFromStorage
  } catch (error) {
    console.error(error)
    newRelicNotifyError(`Error getTracrAnonymousId: ${error}`)
    return undefined
  }
}

export const getTracrSessionId = async () => {
  if (!isClient()) return

  try {
    const valueFromStorage = sessionStorage.getItem(TRACR_SESSION_ID_LABEL)

    if (!valueFromStorage) return undefined

    return valueFromStorage
  } catch (error) {
    console.error(error)
    newRelicNotifyError(`Error getTracrSessionId: ${error}`)
    return undefined
  }
}

const trackEvents = {
  formInteracted: ({ cnpj = '', name = '', email = '', phone = '' }) => {
    const payload = {
      cnpj,
      name,
      phone,
      mail: email
    }

    sendEvent('equifax.FormInteracted', payload, 'V2')
  },
  nps: (payload) => {
    sendEvent('equifax.NPS', { ...payload, grade: Number(payload.grade) }, 'V2')
  },
  redTesting: (payload) => {
    sendEvent('redtesting.Tracked', payload)
  }
}

export const triggerTracrTrack = (name, data) => {
  if (name in trackEvents) {
    const event = trackEvents[name]
    return event(data)
  } else {
    const error = new Error(`[@analytics] ${name} does not exit in events`)

    return Promise.reject(error)
  }
}
